import {post} from '@/utils/request';
import {erpplatserver} from '@/utils/baseUrl';
import {baseerp} from '@/utils/baseUrl';

//获取登陆人的菜单权限
export async function getMenuoperation(params) {
    return post(erpplatserver+'/menu/initMenu', params, true)
}
//注销用户
export async function logout(params) {
    return post(erpplatserver+'/login/logout', params, true)
}

